import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { Typography, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setPGState } from "../productGroupSetupSlice";
import { update } from "lodash";

const addBtnText = "Add >";
const addAllBtnText = "Add All >>";
const remBtnText = "< Remove";
const remAllBtnText = "<< Remove All";

function not(a, b) {
	return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
	return a.filter((value) => b.indexOf(value) !== -1);
}

export default function CreateTransferList({
	leftList,
	rightList,
	leftState,
	rightState
}) {

   const pgState = useSelector((store) => store.productGroupSetup);
   const {
      createFromDate,
      createToDate,
      selectedSKUs,
	  is_sku_refresh,
	  is_refresh
   } = pgState;

	const [checked, setChecked] = useState([]);
	const [left, setLeft] = useState([]);
	const [right, setRight] = useState([]);
	const [countLeft, setCountLeft] = useState(0);
	const [countRight, setCountRight] = useState(0);
	const [selectionStart, setSelectionStart] = useState(null);
	const [startIndex, setStartIndex] = useState(null);
	const leftChecked = intersection(checked, left);
	const rightChecked = intersection(checked, right);
	const [isLeftAllSelected, setIsLeftAllSelected] = useState(false);
	const [isRightAllSelected, setIsRightAllSelected] = useState(false);
 

	const isTab = useMediaQuery("(max-width: 800px)");

	const dispatch = useDispatch();

	useEffect(() => {
		if (leftList?.length >= 0) {
			setLeft(leftList);
		}
		if (rightList?.length >= 0) {
			setRight(rightList);
		}
	}, [leftList, rightList]);

	useEffect(() => {
		setCountLeft(left.length);
		setCountRight(right.length);
	}, [left, right]);

	useEffect(()=>{
		if(is_sku_refresh){
			dispatch(setPGState("is_sku_refresh", false));
			setIsLeftAllSelected(false);
		}
	}, [is_sku_refresh]);

	useEffect(()=>{
		if(is_refresh){
			dispatch(setPGState("is_refresh", false));
			setIsLeftAllSelected(false);
			setIsRightAllSelected(false);
		}
	}, [is_refresh]) 

	const handleToggle = (event, index, value, side) => {
		if (event.shiftKey && startIndex !== null) {
			const start = Math.min(startIndex, index);
			const end = Math.max(startIndex, index);
			let a = [];
			if (side === "left") {
				a = JSON.parse(JSON.stringify(left));
			} else {
				a = JSON.parse(JSON.stringify(right));
			}
			const newSelectedItems = a.slice(start, end + 1);
			console.log(newSelectedItems);

			const newChecked = [];
			for (let i = 0; i < newSelectedItems.length; i++) {
				const currentIndex = newChecked.findIndex((item) => getItemId(item) === getItemId(newSelectedItems[i]));
				let item = [];
				if (side === "left") {
					item = left.find((item) => getItemId(item) === getItemId(newSelectedItems[i]));
				} else {
					item = right.find((item) => getItemId(item) === getItemId(newSelectedItems[i]));
				}

				if (currentIndex === -1) {
					newChecked.push(item);
				} else {
					newChecked.splice(currentIndex, 1);
				}

			}
			setChecked(newChecked);
		}
		else {
			const currentIndex = checked.indexOf(value);
			console.log(event)
			const newChecked = [...checked];

			if (currentIndex === -1) {
				newChecked.push(value);
				setStartIndex(index)
			} else {
				newChecked.splice(currentIndex, 1);
				setStartIndex(null)
			}

			setChecked(newChecked);
		}
	};
	const handleMouseDown = (e, index) => {
		e.preventDefault();
		setSelectionStart(index);
	};

	const handleMouseMove = (e, side, index) => {
		if (selectionStart !== null && e.shiftKey) {
			const start = Math.min(selectionStart, index);
			const end = Math.max(selectionStart, index);
			let a = [];
			if (side === "left") {
				a = JSON.parse(JSON.stringify(left));
			} else {
				a = JSON.parse(JSON.stringify(right));
			}
			const newSelectedItems = a.slice(start, end + 1);
			console.log(newSelectedItems);
			if (newSelectedItems.length > 0 && newSelectedItems.length < 10) {
				const newChecked = [];
				for (let i = 0; i < newSelectedItems.length; i++) {
					const currentIndex = newChecked.findIndex((item) => getItemId(item) === getItemId(newSelectedItems[i]));
					let item = [];
					if (side === "left") {
						item = left.find((item) => getItemId(item) === getItemId(newSelectedItems[i]));
					} else {
						item = right.find((item) => getItemId(item) === getItemId(newSelectedItems[i]));
					}
					if (currentIndex === -1) {
						newChecked.push(item);
					} else {
						newChecked.splice(currentIndex, 1);
					}

				}
				setChecked(newChecked);
			}
		}
	};
	const handleMouseUp = () => {
		setSelectionStart(null);
	};
	const handleDoubleClick = (item, side) => {
		if (side == "left") {
			dispatch(setPGState(rightState, right.concat(item)));
			let leftlist = JSON.parse(JSON.stringify(left));
			for (let i = 0; i < leftlist.length; i++) {
				if (getItemId(leftlist[i]) === getItemId(item)) {
					leftlist.splice(i, 1);
				}
			}
			leftlist = leftlist.filter(x => getItemId(x) != getItemId(item));
			dispatch(setPGState(leftState, leftlist));
			setRight(right.concat(item));
			setLeft(leftlist);
			let checkedlist = JSON.parse(JSON.stringify(checked));
			checkedlist = checkedlist.filter(x => getItemId(x) != getItemId(item));
			setChecked(checkedlist);
			
		}
		if (side == "right") {
			dispatch(setPGState(leftState, left.concat(item)));
			let rightlist = JSON.parse(JSON.stringify(right));
			// for(let i = 0; i< rightlist.length; i++){
			// 	if(getItemId(rightlist[i]) === getItemId(item)){
			// 		rightlist.splice(i,1);
			// 	}
			// }
			rightlist = rightlist.filter(x => getItemId(x) != getItemId(item));
			dispatch(setPGState(rightState, rightlist));
			setLeft(left.concat(item));
			setRight(rightlist);
			let checkedlist = JSON.parse(JSON.stringify(checked));
			checkedlist = checkedlist.filter(x => getItemId(x) != getItemId(item));
			setChecked(checkedlist);
		}
	}

   function updateSKUDates(list) {
      const updated = list.map((item) => {
         return {
            ...item,
            effectiveStartDate: createFromDate,
            effectiveEndDate: createToDate 
         };
      });
      return updated;
   }

	const handleAllRight = () => {
		setIsLeftAllSelected(false);
        setIsRightAllSelected(false);
		let tempRight = right.concat(left);
      	tempRight = updateSKUDates(tempRight);

		setRight(tempRight);
		setLeft([]);

		dispatch(setPGState(leftState, []));
		dispatch(setPGState(rightState, tempRight));
	};

	const handleCheckedRight = () => {
		setIsLeftAllSelected(false);
        setIsRightAllSelected(false);
      	let updatedLeftChecked = updateSKUDates(leftChecked);
		let tempRight = right.concat(updatedLeftChecked);
		const tempLeft = not(left, leftChecked);

		setRight(right.concat(updatedLeftChecked));
		setLeft(not(left, updatedLeftChecked));
		setChecked(not(checked, updatedLeftChecked));

		dispatch(setPGState(leftState, tempLeft));
		dispatch(setPGState(rightState, tempRight));
	};

	const handleCheckedLeft = () => {
		setIsLeftAllSelected(false);
        setIsRightAllSelected(false);
		const tempLeft = left.concat(rightChecked);
		const tempRight = not(right, rightChecked);

		setLeft(left.concat(rightChecked));
		setRight(not(right, rightChecked));
		setChecked(not(checked, rightChecked));

		dispatch(setPGState(leftState, tempLeft));
		dispatch(setPGState(rightState, tempRight));
	};

	const handleAllLeft = () => {
		setIsLeftAllSelected(false);
        setIsRightAllSelected(false);
		const tempLeft = left.concat(right);

		setLeft(left.concat(right));
		setRight([]);

		dispatch(setPGState(leftState, tempLeft));
		dispatch(setPGState(rightState, []));
	};
	const getItemId = (item) => {
		if (item.hasOwnProperty("productID")) {
			return item.productID;
		} else if (item.hasOwnProperty("id")) {
			return item.id;
		}
	};

   function sortbyName(items, side) {
      let list = items.slice();
      list.sort((first, second) => {
         if(first.productName < second.productName) return -1;
         if(first.productName > second.productName) return 1;
         return 0;
      });
      if(side === "left") {
         dispatch(setPGState("skus", list));
      }
      else {
         dispatch(setPGState("selectedSKUs", list));
      }
   }

   function sortbyNumber(items, side) {
      let list = items.slice();
      list.sort((first, second) => {
         if(first.clientProductCode < second.clientProductCode) return -1;
         if(first.clientProductCode > second.clientProductCode) return 1;
         return 0;
      });
      if(side === "left") {
         dispatch(setPGState("skus", list));
      }
      else {
         dispatch(setPGState("selectedSKUs", list));
      }
   }
   const handleSelectAll = (items, side, isSelect) => {
		if(items?.length > 0){
			if(isSelect){
				setChecked(items);
			}else{
				setChecked([]);
			}
			if (side === "left") {
				setIsLeftAllSelected(isSelect);
				setIsRightAllSelected(false);
			} else{
				setIsRightAllSelected(isSelect);
				setIsLeftAllSelected(false);
			}
		}
 	}

	const customList = (items, count, side) => (
		<>
         { side === "right" ? <Typography variant="subtitle1">Product to be assigned</Typography> : null }
         { side === "left" ? <Typography variant="subtitle1">Search result</Typography> : null }
         <Typography variant="subtitle2" sx={{ cursor: "pointer" }} onClick={() => sortbyName(items, side)} display="inline">Sort by Name | </Typography>
         <Typography variant="subtitle2" sx={{ cursor: "pointer" }} onClick={() => sortbyNumber(items, side)} display="inline">Sort by Number</Typography>
		 <Typography variant="subtitle2">Count: {count}</Typography>
		 {side === "left" && <Typography sx={{ cursor: "pointer" }} variant="subtitle2" onClick={() => handleSelectAll(items, side, !isLeftAllSelected)} >
         {isLeftAllSelected && items?.length > 0 ? "Unselect All" : "Select All"}
         </Typography>}
         {side === "right" && <Typography sx={{ cursor: "pointer" }} variant="subtitle2" onClick={() => handleSelectAll(items, side, !isRightAllSelected)} >
         {isRightAllSelected && items?.length > 0 ? "Unselect All" : "Select All"}
         </Typography>}
			<Paper
				sx={{ width: isTab ? "30vw" : "32vw", height: 280, overflow: "auto" }}
			>
				<List dense component="div" role="list">
					{items.map((sku, index) => {
						const labelId = `transfer-list-item-${sku.productGroupID}-label`;

						return (
							<ListItem
								key={sku.productGroupID}
								role="listitem"
								button
								selected={checked.indexOf(sku) !== -1}
								style={{
									backgroundColor: checked.includes(sku) ? '#f2f1ed' : '',
								}}
								onClick={(event) => handleToggle(event, index, sku, side)}
								onDoubleClick={() => handleDoubleClick(sku, side)}
								onMouseDown={(e) => handleMouseDown(e, index)}
								onMouseMove={(e) => handleMouseMove(e, side, index)}
								onMouseUp={handleMouseUp}
							>
								<ListItemIcon>
									<Checkbox
										checked={checked.indexOf(sku) !== -1}
										tabIndex={-1}
										disableRipple
										inputProps={{
											"aria-labelledby": labelId,
										}}
									/>
								</ListItemIcon>
								<ListItemText
									id={labelId}
									primary={` ${sku.productName}`}
								/>
							</ListItem>
						);
					})}
				</List>
			</Paper>
		</>
	);

	return (
		<Grid container spacing={2} justifyContent="space-between" alignItems="center">
			<Grid item>{customList(left, countLeft,"left")}</Grid>
			<Grid item>
				<Grid container direction="column" alignItems="center">
					<Button
						sx={{ my: 0.5 }}
						variant="outlined"
						size="small"
						onClick={handleAllRight}
						disabled={left.length === 0}
						aria-label="move all right"
					>
						{addAllBtnText}
					</Button>
					<Button
						sx={{ my: 0.5 }}
						variant="outlined"
						size="small"
						onClick={handleCheckedRight}
						disabled={leftChecked.length === 0}
						aria-label="move selected right"
					>
						{addBtnText}
					</Button>
					<Button
						sx={{ my: 0.5 }}
						variant="outlined"
						size="small"
						onClick={handleCheckedLeft}
						disabled={rightChecked.length === 0}
						aria-label="move selected left"
					>
						{remBtnText}
					</Button>
					<Button
						sx={{ my: 0.5 }}
						variant="outlined"
						size="small"
						onClick={handleAllLeft}
						disabled={right.length === 0}
						aria-label="move all left"
					>
						{remAllBtnText}
					</Button>
				</Grid>
			</Grid>
			<Grid item>{customList(right, countRight, "right")}</Grid>
		</Grid>
	);
}
